import { RootState } from '@iwProvider/configureStore';

export const getCompanyAnnualTurnover = (state: RootState) =>
    state?.api?.customer_state?.data?.application?.company
        ?.last_12_months_turnover?.amount;
